module.exports = __webpack_public_path__ + "img/newicon4click.edca63f8.svg";